import React from "react";
import { StyledTitle } from "../../Styled-component/StyledTitle";
import myPic from "../../images/myPic.png";
import { ContactForm } from "./ContactForm";
import { LinksContainer } from "./LinksContainer";
import { GiThink } from "react-icons/gi";
import "./Contact.css";

export const Contact = () => {
  return (
    <div>
      <StyledTitle title="My Contacts" />
      <h1 className="contact-h1" data-aos="fade-down">
        Thanks for spending time in my portfolio. How can I help you today?
        Please send me your feedback.
      </h1>
      <ContactForm />
      <div className="project-section-cont">
        <div className="padding-project-together">
          <div className="project-container" data-aos="fade-down">
            <h1 data-aos="fade-right" data-aos-duration="1200">
              <GiThink />
              Start a Project
            </h1>
            <p data-aos="zoom-in">
              Interested in working together? We should queue up a chat. I’ll
              buy the coffee.
            </p>
            <a
              href="https://www.linkedin.com/in/md-niamul-hakim-936948239/"
              target="_blank"
              rel="noreferrer"
              data-aos="fade-left"
              data-aos-duration="1200">
              Let's do this
            </a>
            <img
              src={myPic}
              alt="mypic"
              className="my-pic-absolute"
              onClick={() =>
                alert(
                  "Hi, I'm Shawn, Please send me your feedback in message section about my portfolio tour, let me know your experience. Thanks for your cooperation :)"
                )
              }
              />
          </div>
          <h2 className="my-quote-contact" data-aos="fade-up">Love to learn & like to travel</h2>
          <div className="button-links-logo-container">
            <LinksContainer />
          </div>
          <h4 className="h4-copyright-contact">
            Md Niamul Hakim Shawn @ {new Date().getFullYear()}
          </h4>
        </div>
      </div>
    </div>
  );
};
